<ngx-loading-bar
  #loading
  color="#3AA36B"
  includeSpinner="false"
  height="3px"
></ngx-loading-bar>

<div id="service-order-management-view">
  <app-new [title]="title" [subtitle]="subtitle" [urlBack]="urlBack">
    <div class="container" *ngIf="serviceOrderManagement">
      <div class="row">
        <div class="col">
          <label>
            <span>BANDEIRA</span>

            <div class="text">
              {{ serviceOrderManagement.loja.dsLogomarca | emptyResponse }}
            </div>
          </label>
        </div>

        <div class="col">
          <label>
            <span>LOJA</span>

            <div class="text">
              {{ serviceOrderManagement.loja.nmFantasia | emptyResponse }}
            </div>
          </label>
        </div>

        <div class="col">
          <label>
            <span>DATA DE ABERTURA</span>

            <div class="text">
              {{ serviceOrderManagement.dtAbertura | emptyResponse }}
            </div>
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label>
            <span>CNPJ</span>

            <div class="text">
              {{ serviceOrderManagement.loja.nrCnpj | emptyResponse }}
            </div>
          </label>
        </div>

        <div class="col">
          <label>
            <span>CENTRO DE CUSTO</span>

            <div class="text">
              {{
                serviceOrderManagement.loja.centroCusto?.nmCentroCusto
                  | emptyResponse
              }}
            </div>
          </label>
        </div>

        <div class="col">
          <label>
            <span>ID JAVA DA LOJA</span>

            <div class="text">
              {{ serviceOrderManagement.cdFilial | emptyResponse }}
            </div>
          </label>
        </div>
      </div>

      <h2>DETALHES DA MANUTENÇÃO</h2>

      <div class="row">
        <div class="col">
          <label>
            <span>PRESTADOR DE SERVIÇO</span>

            <div class="text">
              {{ serviceOrderManagement.nmFantasia | emptyResponse }}
            </div>
          </label>
        </div>

        <div class="col">
          <label>
            <span>TIPO DO SERVIÇO</span>

            <div class="text">
              {{ serviceOrderManagement.dsTpServico | emptyResponse }}
            </div>
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label>
            <span>RELATO DO CHAMADO</span>

            <div class="text">
              {{ serviceOrderManagement.dsObservacao | emptyResponse }}
            </div>
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <h2>VALORES TOTAIS</h2>

          <div class="row">
            <div class="col">
              <label>
                <span>TOTAL GERAL</span>

                <div class="text">{{ total | currencyFormat }}</div>
              </label>
            </div>

            <div class="col">
              <label>
                <span>APROVAÇÃO</span>

                <div class="text">
                  {{ serviceOrderManagement.dsAprovacao | emptyResponse }}
                </div>
              </label>
            </div>
          </div>
        </div>

        <div class="col">
          <h2>EXTRATO</h2>

          <label>
            <div class="row">
              <span class="col">EQUIPAMENTOS</span>
              <span class="col">VALOR UNIT.</span>
            </div>

            <table>
              <tr class="row" *ngFor="let item of serviceOrderManagement.items">
                <td class="col">{{ item.dsProduto }}</td>
                <td class="col">{{ item.vlItem | currencyFormat }}</td>
              </tr>
            </table>
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <button class="white" (click)="disapproved()">
            REPROVAR ORDEM DE SERVIÇO
          </button>

          <button (click)="approved()">APROVAR ORDEM DE SERVIÇO</button>
        </div>
      </div>
    </div>
  </app-new>
</div>
